import { getSsrState } from 'src/utils/ssr.js';
import { createVueApp } from 'src/utils/vue.js';

import CreateRecommendationLetterPage
  from 'src/components/users/CreateRecommendationLetterPage/CreateRecommendationLetterPage.vue';
import VisitorProvider from 'src/components/users/VisitorProvider/VisitorProvider.vue';

const container = document.querySelector('[data-root]');

if (container) {
  const { user, fields, placeholder, visitor } = getSsrState();

  const app = createVueApp({
    render(h) {
      return h(VisitorProvider, {
        props: {
          visitor,
        },
      }, [
        h(CreateRecommendationLetterPage, {
          props: {
            user,
            fields,
            placeholder,
          }
        })
      ])
    },
  });

  app.$mount(container);
}